// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMessageReviewAdmin-root-wbVOP {
	padding-left: 20px;
	padding-right: 20px;
}

.ViewMessageReviewAdmin-container-sLPf5 {
	margin: 0px auto;
	padding-top: 30px;
	max-width: var(--max-content-width);
}

a,
a:hover {
	color: var(--btn-secondary-bg);
}

.ViewMessageReviewAdmin-bgColor-zrl6x {
	width: 100%;
	background: #F7FAFF;
}

@media (max-width: 1023px) and (min-width: 768px) {
	.ViewMessageReviewAdmin-bgColor-zrl6x {
		padding: 0 10px;
	}
}

@media (max-width: 767px) {
	.ViewMessageReviewAdmin-bgColor-zrl6x {
		padding: 0 10px;
	}
}`, "",{"version":3,"sources":["webpack://./src/routes/messageReviewAdmin/ViewMessageReviewAdmin.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,mCAAmC;AACpC;;AAEA;;CAEC,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0px auto;\n\tpadding-top: 30px;\n\tmax-width: var(--max-content-width);\n}\n\na,\na:hover {\n\tcolor: var(--btn-secondary-bg);\n}\n\n.bgColor {\n\twidth: 100%;\n\tbackground: #F7FAFF;\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n\t.bgColor {\n\t\tpadding: 0 10px;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.bgColor {\n\t\tpadding: 0 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ViewMessageReviewAdmin-root-wbVOP`,
	"container": `ViewMessageReviewAdmin-container-sLPf5`,
	"bgColor": `ViewMessageReviewAdmin-bgColor-zrl6x`
};
module.exports = ___CSS_LOADER_EXPORT___;
